export const REALTOR_PORTAL_ACCESS_LABEL = 'Realtor Portal access';

export const GRANT_ACCESS_CONFIRMATION = {
  message: 'Grant Realtor Portal access',
  description:
    'This lets the selected realtor view this loan in the Realtor Portal. Access stays until you remove it.',
};
